import { render, staticRenderFns } from "./ServiceItems.vue?vue&type=template&id=23f6551c&scoped=true&"
import script from "./ServiceItems.vue?vue&type=script&lang=js&"
export * from "./ServiceItems.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItems.vue?vue&type=style&index=0&id=23f6551c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6551c",
  null
  
)

export default component.exports